import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { queryClient } from '../react-query';
import axios from './axios';

export interface UseUpdateOrganizationThemeVariables {
  color_palette?: number;
  landing_background_image?: number;
  landing_box_position?: 'center' | 'left' | 'right';
}

export interface UseUpdateOrganizationThemeData {
  color_palette: number;
  landing_background_image: number;
  landing_box_position: 'center' | 'left' | 'right';
}

export function useUpdateOrganizationTheme() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseUpdateOrganizationThemeData,
    AxiosError<UseUpdateOrganizationThemeData>,
    UseUpdateOrganizationThemeVariables
  >(
    (variables) => {
      const data = variables;

      return axios
        .put<UseUpdateOrganizationThemeData>(
          '/posht/picasso/organization/theme/',
          data,
        )
        .then((res) => res.data);
    },
    {
      onError: () => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
      onSuccess: () => {
        enqueueSnackbar(t('operation.successful'), { variant: 'success' });
      },
      onSettled: () => {
        queryClient.invalidateQueries('organization-theme');
      },
    },
  );
}
